import { Languages } from "../../enums/languages";
import PermitType from "../../types/permit.type";

const formLang = {
    "input-label": {
        "street": {
            [Languages.Hebrew]: {
                default: 'רחוב'
            },
            [Languages.Arabic]: {
                default: 'شارع'
            },
            [Languages.English]: {
                default: 'Street'
            }
        },
        "permit-type": {
            [Languages.Hebrew]: {
                default: 'סוג תו'
            },
            [Languages.Arabic]: {
                default: 'نوع التصريح'
            },
            [Languages.English]: {
                default: 'Permit Type'
            }
        }
    },
    "permit-type-options": {
        [PermitType.REGULAR]: {
            [Languages.Hebrew]: {
                32: 'תו תושב',
                25: 'תו חנייה שנתי',
                default: 'תו דייר'
            },
            [Languages.Arabic]: {
                32: 'تصريح المقيم',
                25: 'تصريح موقف سنوي',
                default: 'تصريح ساكن'
            },
            [Languages.English]: {
                32: 'Resident Permit',
                25: 'Annual Parking Permit',
                default: 'Resident Permit'
            }
        },
        [PermitType.GOLDEN]: {
            [Languages.Hebrew]: {
                default: 'תו גיל זהב'
            },
            [Languages.Arabic]: {
                default: 'تصريح سن ذهبي'
            },
            [Languages.English]: {
                default: 'Golden Age Permit'
            }
        },
        [PermitType.STUDENT]: {
            [Languages.Hebrew]: {
                default: 'סטודנט'
            },
            [Languages.Arabic]: {
                default: 'طالب'
            },
            [Languages.English]: {
                default: 'Student'
            }
        },
        [PermitType.HANDICAPPED]: {
            [Languages.Hebrew]: {
                default: 'בעל תו נכה'
            },
            [Languages.Arabic]: {
                default: 'تصريح لذوي الإعاقة'
            },
            [Languages.English]: {
                default: 'Handicapped Permit'
            }
        },
        [PermitType.MUNICIPAL_EMPLOYEE]: {
            [Languages.Hebrew]: {
                default: 'עובד עירייה'
            },
            [Languages.Arabic]: {
                default: 'موظف بلدية'
            },
            [Languages.English]: {
                default: 'Municipal Employee'
            }
        },
        [PermitType.TAXI]: {
            [Languages.Hebrew]: {
                25: 'תו חנייה מונית',
                default: 'מונית'
            },
            [Languages.Arabic]: {
                25: 'تصريح موقف تاكسي',
                default: 'تاكسي'
            },
            [Languages.English]: {
                25: 'Taxi Parking Permit',
                default: 'Taxi'
            }
        },
        [PermitType.PERMIT_BY_ZONE]: {
            [Languages.Hebrew]: {
                32: 'תו דייר - צמוד רחוב',
                25: 'תו חנייה אזורי',
                default: 'תו אזורי'
            },
            [Languages.Arabic]: {
                32: 'تصريح ساكن - بجانب الشارع',
                25: 'تصريح موقف إقليمي',
                default: 'تصريح إقليمي'
            },
            [Languages.English]: {
                32: 'Resident Permit - Street Adjacent',
                25: 'Regional Parking Permit',
                default: 'Regional Permit'
            }
        },
        [PermitType.NONE_RESIDENT]: {
            [Languages.Hebrew]: {
                default: 'תושב חוץ'
            },
            [Languages.Arabic]: {
                default: 'غير مقيم'
            },
            [Languages.English]: {
                default: 'Non-Resident'
            }
        },
        [PermitType.BUSINESS]: {
            [Languages.Hebrew]: {
                default: 'תו - עסק'
            },
            [Languages.Arabic]: {
                default: 'تصريح - عمل'
            },
            [Languages.English]: {
                default: 'Permit - Business'
            }
        },
        [PermitType.ALL]: {
            [Languages.Hebrew]: {
                default: 'הכל'
            },
            [Languages.Arabic]: {
                default: 'الكل'
            },
            [Languages.English]: {
                default: 'All'
            }
        },
        'all_types': {
            [Languages.Hebrew]: {
                default: 'כל הסוגים'
            },
            [Languages.Arabic]: {
                default: 'جميع الأنواع'
            },
            [Languages.English]: {
                default: 'All Types'
            }
        },
        'empty': {
            [Languages.Hebrew]: {
                default: 'אנא בחר'
            },
            [Languages.Arabic]: {
                default: 'يرجى الاختيار'
            },
            [Languages.English]: {
                default: 'Please select'
            }
        }
    },
    "defualt-options": {
        "need-to-select": {
            [Languages.Hebrew]: {
                default: 'אנא בחר אפשרות'
            },
            [Languages.Arabic]: {
                default: 'يرجى اختيار خيار'
            },
            [Languages.English]: {
                default: 'Please select an option'
            },
        }
    }
}

export default formLang;